function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 30C23.2875 30 30 23.2875 30 15C30 6.7125 23.2875 0 15 0C6.7125 0 0 6.7125 0 15C0 23.2875 6.7125 30 15 30ZM15 1.875C22.2375 1.875 28.125 7.7625 28.125 15C28.125 22.2375 22.2375 28.125 15 28.125C7.7625 28.125 1.875 22.2375 1.875 15C1.875 7.7625 7.7625 1.875 15 1.875Z",
  fill: "#1442A8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2875 20.25C11.55 20.25 11.8125 20.1375 12 19.9125L15.7125 15.6C15.8625 15.4125 15.9375 15.225 15.9375 15V7.57501C15.9375 7.05001 15.525 6.63751 15 6.63751C14.475 6.63751 14.0625 7.05001 14.0625 7.57501V14.6625L10.575 18.7125C10.2375 19.0875 10.275 19.6875 10.6875 20.025C10.8375 20.175 11.0625 20.25 11.2875 20.25Z",
  fill: "#1442A8"
});

var SvgCleanOneTime = function SvgCleanOneTime(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCleanOneTime, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clean_one_time.a2ee6269.svg";
export { ForwardRef as ReactComponent };